import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

    getPaymentMethods(){
        let url = 'get_payment_methods';
        return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
    }

    checkout(pm){
        let url = 'checkout';
        return this.http.post(this.BASE_URL_API_WEBSITE + url,pm,this.storage.getHeaders())
    }

    anonymousDonation(body){
      let url = 'public/anonymous_donation';
        return this.http.post(this.BASE_URL_API + url,body,this.storage.getHeaders())
    }

    fundraiserTitle(fm_id){
      let url = 'public/fundraiser_title?fundraiser_master_id=' + fm_id;
        return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
    }

    // addToCart(item){
    //     let url = 'add_to_cart';
    //     return this.http.post(this.BASE_URL_API_WEBSITE + url,item,this.storage.getHeaders())
    // }

    // updateQtyCart(item){
    //     let url = 'update_qty_cart';
    //     return this.http.post(this.BASE_URL_API_WEBSITE + url,item,this.storage.getHeaders())
    // }

    // removeItemCart(order_detail_id){
    //     let url = 'remove_item_cart?order_detail_id=' + order_detail_id;
    //     return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
    // }




}
